module.exports = __webpack_public_path__ + "img/bgindex.69519889.png";